export default __webpack_public_path__ + "media/images/payments/amex-359f938df35e68157cdf20d8c4e12ef7.svg";